"use client";
import { useAuth } from "@/context/auth-context";
import useCMSColorInitializer from "@/utils/hooks/useCMSColorInitializer";
import dynamic from "next/dynamic";

const HomePage = dynamic(() => import("@/features/home/HomePage"), {
  loading: () => <div className="h-screen" />
});
const LandingPage = dynamic(() => import("@/features/landing/LandingPage"), {
  ssr: false,
  loading: () => <div className="h-screen" />
});
export default function EServicesPage() {
  const { authState } = useAuth();
  useCMSColorInitializer();

  if (authState?.token) return <HomePage />;

  return <LandingPage />;
}
